import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { AppleWifiProfilePreset } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel } from '@era/app';

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const WifiProfileApiActions = createActionGroup({
  source: 'Wifi profile API',
  events: {
    'Profiles loaded': props<{ profiles: AppleWifiProfilePreset[] }>(),
    'Profiles loaded error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const WifiProfileResolverActions = createActionGroup({
  source: 'Wifi profile resolver',
  events: {
    'Profiles requested': emptyProps(),
  },
});
